import react, { useState, useEffect, useContext, createContext } from 'react'

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {

    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    // Check authentication status on mount and when storage changes
    useEffect(() => {
        const checkAuth = () => {
            // Check for both token and session_token
            const token = localStorage.getItem('token');
            const sessionToken = localStorage.getItem('session_token');
            const newAuthState = !!(token || sessionToken);
            setIsAuthenticated(newAuthState);
            setLoading(false);
        };
        
        checkAuth();
        
        // Listen for storage changes (in case token is set in another tab/window)
        const handleStorageChange = (e) => {
            if (e.key === 'token' || e.key === 'session_token') {
                checkAuth();
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [])

    const login = (token) => {
        console.log('[AUTH_CONTEXT] login() called - Token: ' + (token ? token.substring(0, 10) + '...' : 'NULL'));
        // Save both token and session_token for compatibility
        localStorage.setItem('token', token);
        localStorage.setItem('session_token', token);
        setIsAuthenticated(true);
        setLoading(false); // Make sure loading is false after login
        console.log('[AUTH_CONTEXT] State updated - isAuthenticated: true, loading: false');
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('session_token');
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    )
    // Custom hook to use auth context

}
export const useAuth = () => {
    return useContext(AuthContext);
};
